<template>
    <h1 class="alert alert-light d-flex justify-content-center text-center">
صفحه در حال طراحی میباشد
      <br/>
      به زودی با امکانات بهتر در دسترس خواهد بود
    </h1>
</template>

<script>
export default {
  name: "comming-soon",
  created: () => {},
  components: {},
  data() {
    return {};
  }
};
</script>
